import theme from "../../themes/default";
const styles = {
    wrapper: {
        position: "fixed",
        top: "50%",
        left: "50%",
        width: "50%",
        height: "400px",
        transform: "translate(-50%, -50%)",
        flexDirection: "column",
        justifyContent: "center",
        border: `3px solid ${theme.palette.primary.main}`,

    },
    loader: {
        position: "absolute",
        top: "50%",
        left: "50%",
    },
    title: {
        width: "100%",
        height: "25%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
    },
    dialogTitle: {
        fontWeight: "700",
        opacity: 1,
        fontSize: "1.2vw"
    },
    paragraph: {
        fontSize: "2vw", fontWeight: "700", color: "#333333"
    },
    loginForm: {
        backgroundColor: theme.palette.primary.main,
        width: "100%",
        height: "75%",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-around",
        flexDirection: "column",
        boxSizing: "border-box",
        pb: "3%"
    },
    connect: {
        fontSize: "1.5vw",
        fontWeight: "700",
        color: "#fdfdfd"
    },
    details: {
        "& .MuiOutlinedInput-root": {
            background: "white",
            "& > fieldset": {
                border: "1px solid #797979",
            },
            "& input::placeholder": {
                fontSize: "1.2vw",
                color: " #545353",
                opacity: 1,


            },
            // height: "8vh",
        },
        width: "47%"
    },
    submit: {
        fontWeight: 700,
        fontSize: "1.2vw",
        backgroundColor: "#000000",
        color: "#ffffff",
        "&:hover": {
            backgroundColor: "#ffffff",
            color: "#000000"
        },
        pt: "2%",
        width: "30%",
    },
    delete: {
        color: "#000000",
        border: "2px solid black",
        fontWeight: 700,
        fontSize: "1.2vw",
        "&:hover": {
            backgroundColor: "#ffffff",
            color: "#000000",
            border: "2px solid black"
        },
        pt: "2%",
        width: "30%",
    },

    backButton: {
        boxShadow: theme => theme.customShadows.widget,
        textTransform: "none",
        fontSize: 22,
    },
    form: {
        width: "80%",
        height: "70%",
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-between"
    },
    content: {
        color: theme.palette.text.primary,
        opacity: 1
    },
    actionBox: {
        display: "flex",
        justifyContent: "center"
    }

};

export default styles;